/**
 * Retire les balise HTML d'un string
 * @param {*} value le string à nettoyer
 * @returns un string sans balise html
 */
const stripHtml = (value) => {
  // Si value est vide ou null, on retourne une chaine vide
  if (!value) {
      return ''
  }

  return value.replace(/(<([^>]+)>)/gi, "").trim()
}


/**
 * Formate l'affichage d'un string en testant son existence
 * @param {*} value le string à formater 
 * @returns la valeur formatée ou "-"
 */
const formatString = (value) => {
  if (value) {
    return value
  } else {
    return '-'
  }
}


export { stripHtml, formatString }